/**
 * Copyright (c) 2023, CYBRA Corp. All rights reserved.
 */
export enum Comparison {
  IS = 'is',
    IS_NOT = 'is not',
    CONTAINS = 'contains',
    GREATER_THAN = 'greater than',
    LESS_THAN = 'less than'
}
